import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=0508e4b9&scoped=true"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=0508e4b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508e4b9",
  null
  
)

export default component.exports